import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActionBtn } from '../../../classes/action-btn';
import { ISignInErrorInfo } from '../../../classes/sign-in-error';

@Component({
	selector: 'sign-in-error',
	template: require('./sign-in-error.component.html'),
})
export class SignInErrorComponent {
	@Input() info: ISignInErrorInfo;
	@Output() onActionClick = new EventEmitter<ActionBtn>();

	public actionClicked(): void {
		if (!this.info || !this.info.action) return;
		this.onActionClick.next(this.info.action);
	}
}
